import { ROUTES } from "@/constants/routes";
import { createMagicLinkPattern } from "@/utils/publicRoutes";

/**
 * Determines whether a given API URL should NOT trigger an auth redirect when it returns 401.
 *
 * @param {string} url - Full URL to check
 * @param {string} baseUrl - Base URL to remove
 * @param {string[]} allowedPatterns - Array of URL patterns that are allowed to return 401
 * @returns {boolean} - True if the URL matches an allowed pattern
 */
export const shouldSkipAuthRedirect = (url, baseUrl, allowedPatterns) => {
  // Normalize URL: remove base, strip query and hash if any
  const withoutBase = url.replace(baseUrl, "");
  const cleanUrl = withoutBase.split("?")[0].split("#")[0];

  return allowedPatterns.some((pattern) => {
    if (pattern === ROUTES.PROVIDER_TEST_API) {
      // For magic link API, match the pattern with dynamic slug
      const magicLinkPattern = createMagicLinkPattern(pattern);
      return magicLinkPattern.test(cleanUrl);
    }
    // Require exact match for other patterns
    return cleanUrl === pattern;
  });
};
